var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-code-card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 text-left code"},[_c('strong',[_vm._v(_vm._s(_vm.$t('generic.code', 'Code'))+":")]),_c('span',[_vm._v(_vm._s(_vm.code))])]),_c('div',{staticClass:"col-6 text-right uses"},[_vm._v("\n      "+_vm._s(_vm.$t(
          'pages.my-account.promos.card.uses',
          '{remaining} uses out of {limit}',
          {remaining: _vm.limit - _vm.used, limit: _vm.limit}
        ))+"\n    ")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right type"},[(_vm.type === 'offer')?_c('div',[_vm._v("\n        "+_vm._s(_vm.$t(
            'pages.my-account.promos.card.discount',
            '{discount} € discount for offer!',
            {discount: _vm.discount}
          ))+"\n      ")]):(_vm.type === 'multiprovincia')?_c('div',[_vm._v("\n        "+_vm._s(_vm.$t(
            'pages.my-account.promos.card.multiprovince',
            'Multiprovince promo for {count} provinces!',
            { count: _vm.discount }
          ))+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }